module.exports = __webpack_public_path__ + "media/images/logo-9e36f463.png";